export const contentTypeMap = {
  phase1: 'pageLandingPage',
  phase2: 'pageLandingPagePhase2',
  phase3: 'pageLandingPagePhase3'
}
export function setContentType(req: any) {
  const { phase: phaseFromQuery } = req?.ctx?.query || {}
  // 留测试头
  const phaseFromHeader = req?.headers?.['x-custom-phase']

  if (phaseFromQuery === '1' || phaseFromHeader === '1') {
    return contentTypeMap.phase1
  }
  // preview请求默认展示新内容
  if (phaseFromQuery === '2' || phaseFromHeader === '2') {
    return contentTypeMap.phase2
  }
  if (phaseFromQuery === '3' || phaseFromHeader === '3') {
    return contentTypeMap.phase3
  }

  return req?.contentfulConfigFromTCC?.contentType ?? contentTypeMap.phase2
}
